import { render } from "./Importacao.vue?vue&type=template&id=41ce3b54"
import script from "./Importacao.vue?vue&type=script&lang=js"
export * from "./Importacao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__